// extracted by mini-css-extract-plugin
export var h1 = "dG_h9";
export var h2 = "dG_jb";
export var h3 = "dG_jc";